import { useState } from "react";
import { sendClinicMail } from "../api/mail";
import "./Appointment.css";

const initialForm = {
  name: "",
  age: "",
  email: "",
  phone: "",
  date: "",
  time: "",
  message: "",
};

export default function Appointment() {
  const [formData, setFormData] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", text: "" });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", text: "" });

    try {
      await sendClinicMail({
        ...formData,
        type: "appointment",
        subject: "SmileHub appointment request",
      });
      setStatus({
        type: "success",
        text: "Appointment booked successfully. We will confirm with you shortly.",
      });
      setFormData(initialForm);
    } catch {
      setStatus({
        type: "error",
        text: "Could not send your request. Please call the clinic or try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <section className="appointment section" id="appointment">
      <div className="container">
        <h2 className="section-title">Book an Appointment</h2>
        <form className="clinic-form" onSubmit={handleSubmit}>
          <input
            name="name"
            placeholder="Full Name"
            autoComplete="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            name="age"
            type="number"
            min="1"
            max="120"
            inputMode="numeric"
            placeholder="Age"
            value={formData.age}
            onChange={handleChange}
            required
          />
          <input
            name="email"
            type="email"
            placeholder="Email"
            autoComplete="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            name="phone"
            type="tel"
            placeholder="Phone Number"
            autoComplete="tel"
            inputMode="tel"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <input
            name="date"
            type="date"
            min={today}
            value={formData.date}
            onChange={handleChange}
            required
            aria-label="Preferred date"
          />
          <input
            name="time"
            type="time"
            value={formData.time}
            onChange={handleChange}
            required
            aria-label="Preferred time"
          />
          <textarea
            name="message"
            placeholder="Message / Symptoms / Notes"
            value={formData.message}
            onChange={handleChange}
          />
          <button className="btn" type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit Appointment"}
          </button>
          {status.text && (
            <p className={`form-status ${status.type}`}>{status.text}</p>
          )}
        </form>
      </div>
    </section>
  );
}
